import { userService } from "@/services/userService";
import { now } from "@/utils/dateTimeUtils";
import { formatMinutes } from "@/utils/formatUtils";
import { DateTime } from "luxon";

const ShoppingCartTimerMixin = {
  data() {
    return {
      now: now(),
      intervalId: null as number|null
    }
  },
  created() {
    (this as any).intervalId = setInterval(() => {
      (this as any).now = now()
      if ((this as any).hasExpired()) {
        userService.refreshShoppingCart().then(() => {
          if ((this as any).hasExpired()) {
            userService.resetShoppingCart().then(() => {
              (this as any).$router.push({
                path: '/',
                query: {
                  reset: 'y'
                }
              })
            })
          }
        })
      }
    }, 5000)
  },
  methods: {
    hasExpired(): boolean {
      const expiration = (this as any).$store.state.transactionExpiration as DateTime|null
      if (!expiration) {
        return false
      }
      return (this as any).remainingMinutes() < 0;
    },
    remainingMinutes(): number|undefined {
      const expiration = (this as any).$store.state.transactionExpiration as DateTime|null
      if (!expiration) {
        return undefined
      }
      return formatMinutes(expiration.diff((this as any).now as DateTime, 'minutes').minutes)
    },
    hasRemainingTime(): boolean {
      const expiration = (this as any).$store.state.transactionExpiration as DateTime|null
      return !!expiration
    },
  },
  beforeUnmount() {
    if (typeof (this as any).intervalId === 'number') {
      clearInterval((this as any).intervalId)
    }
  }
}

export default ShoppingCartTimerMixin
